import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { base_url } from "../Api/Api";
import { Loader } from "../Global/Loader";
import { Popup } from "../Global/Popup";
import Button from "@material-ui/core/Button";

import Navbar from "../Global/Navbar";
import Header from "../Global/Header";
import Cookies from "universal-cookie";

const Profile = (props) => {
  const [state, setState] = useState({
    data: [],
    userStore: [],
    loader: true,
    popupStatus: false,
  });
  const [links, setLinks] = useState([
    {
      iconName: "icon-present-box-1",
      name: "قرعه کشی های من",
      linkd: "/lottery",
    },
    {
      iconName: "icon-edit-1",
      name: "ویرایش حساب کاربری",
      linkd: "/myAccount/personalInfo",
    },
    {
      iconName: "icon-present-box-1",
      name: "تیکت",
      linkd: "/tickets",
    },
    {
      iconName: "icon-mortarboard-3-fill",
      name: "کورس های من",
      linkd: "/myCourses",
    },
    {
      iconName: "icon-certificate",
      name: "گواهینامه های من",
      linkd: "/myLicenses",
    },
    {
      iconName: "icon-Group-40441",
      name: "درباره ما",
      linkd: "https://s-plus.ir/itemWebView/100",
      blank: true,
    },
    {
      iconName: "icon-phone-call",
      name: "تماس با ما",
      linkd: "https://s-plus.ir/itemWebView/102",
      blank: true,
    },
    {
      iconName: "icon-Group-40441",
      name: "قوانین و مقررات",
      linkd: "https://s-plus.ir/itemWebView/101",
      blank: true,
    },
  ]);

  useEffect(() => {
    if (JSON.parse(localStorage.getItem("logined")) == null) {
      props.history.push(`/Entrance`);
    }

    base_url
      .get("splash")
      .then((response) => {
        base_url.get("panel_stat").then((res) => {
          setState({
            ...state,
            userStore: res.data.stores,
            data: response.data.profile,
            loader: false,
          });
        });
      })
      .catch((error) => {
        if (error.response != undefined) {
          if (error.response.status == 401) {
            localStorage.clear();
            props.history.push(`/Entrance`);
            window.location.reload();
          }
        }
      });
  }, []);
  const accountPopup = () => {
    setState({
      ...state,
      popupStatus: !state.popupStatus,
    });
  };

  const exitAccount = () => {
    const cookies = new Cookies();
    cookies.remove("api_key");
    props.history.push(`/Entrance`);
    window.location.reload();
  };
  return (
    <div className="instructpg profile">
      <Loader active={state.loader} />
      <Popup active={state.popupStatus}>
        <h4>خروج از حساب کاربری</h4>
        <span>آیا مطمئن هستید ؟</span>
        <div className="btn-base btn-black btn-sircle">
          <Button variant="contained" onClick={(e) => exitAccount()}>
            تایید
          </Button>
          <Button variant="contained" onClick={() => accountPopup()}>
            لغو
          </Button>
        </div>
      </Popup>
      <Header />
      <div className="inner-profile">
        <div className={`pic ${state.loader ? "active" : ""}`}>
          <img
            src={state.data.length == 0 ? null : state.data.profile_photo_url}
          />
        </div>
        <h4 className={`${state.loader ? "active" : ""}`}>
          {state.data.length == 0 ? null : state.data.full_name}
        </h4>
        <span className={`${state.loader ? "active" : ""}`}>
          {state.userStore.length == 0 ? "Sdfs" : state.userStore[0].name}
        </span>
        <span className={`${state.loader ? "active" : ""}`}>
          {state.data.length == 0 ? null : state.data.mobile}
        </span>
        <Link to="/myScore" className={`score ${state.loader ? "active" : ""}`}>
          <div className="details">
            <i className="icon-black-star-silhouette"></i>
            <span>امتیازات من</span>
            <strong>({state.data.score})</strong>
          </div>
          <i className="icon-arrow-down-sign-to-navigate"></i>
        </Link>
        <div className={`links-prifile ${state.loader ? "active" : ""}`}>
          {links.map((info) =>
            info.blank ? (
              <a href={info.linkd} className="item-links">
                <div className="details">
                  <i className={info.iconName}></i>
                  <span>{info.name}</span>
                </div>
                <i className="icon-arrow-down-sign-to-navigate"></i>
              </a>
            ) : (
              <Link to={info.linkd} className="item-links">
                <div className="details">
                  <i className={info.iconName}></i>
                  <span>{info.name}</span>
                </div>
                <i className="icon-arrow-down-sign-to-navigate"></i>
              </Link>
            )
          )}
          <button
            type="button"
            className="item-links"
            onClick={() => accountPopup()}
          >
            <div className="details">
              <i className="icon-logout-3"></i>
              <span>خروج از حساب کاربری</span>
            </div>
          </button>
        </div>
      </div>
      <Navbar />
    </div>
  );
};

export default Profile;
